import React from 'react'
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box
} from '@mui/material'
import { Book as BookIcon } from '@mui/icons-material'

const BookCard = ({ book, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <Card
      sx={{
        height: 'auto',
        cursor: 'pointer',
        transition: 'all 0.3s ease-in-out',
        border: '2px solid #e0e0e0',
        '&:hover': {
          transform: 'translateY(-6px)',
          boxShadow: 12,
          border: '2px solid #1976d2'
        }
      }}
      onClick={handleClick}
    >
      <CardMedia
        component="img"
        sx={{
          width: '100%',
          aspectRatio: '3/4',
          objectFit: 'cover',
          backgroundColor: '#f5f5f5'
        }}
        image={book.imageUrl || '/sample-book.jpg'}
        alt={book.title}
        onError={(e) => {
          // Resim yüklenemezse varsayılan ikon göster
          e.target.style.display = 'none'
          e.target.nextSibling.style.display = 'flex'
        }}
      />
      
      {/* Fallback icon */}
      <Box
        sx={{
          width: '100%',
          aspectRatio: '3/4',
          display: book.imageUrl ? 'none' : 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f5f5f5'
        }}
      >
        <BookIcon sx={{ fontSize: 80, color: '#ccc' }} />
      </Box>
      
      <CardContent sx={{ p: 2.5 }}>
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 'bold',
            color: '#333',
            fontSize: '18px',
            lineHeight: 1.3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical'
          }}
        >
          {book.title}
        </Typography>
      </CardContent>
    </Card>
  )
}

export default BookCard
